/* Lawazen - product page "Manuals and training": lists the model's documents
   from the same data as /pages/manuals (LZ_DOCS.machines / .catalogues).
   The model name comes from the product metafield lawazen.docs_model. */
(function () {
  'use strict';
  var box = document.querySelector('[data-lz-pdocs]');
  if (!box || !window.LZ_DOCS) return;
  var list = box.querySelector('[data-lz-pdocs-list]');
  var model = box.getAttribute('data-model');
  var base = box.getAttribute('data-filebase') || '';
  var LABEL = { manual: lzT('Operating manual'), tds: lzT('Datasheet'), safety: lzT('Safety'), elec: lzT('Electrical'), pack: lzT('Packaging'), cat: lzT('Catalogue') };
  var ORDER = ['manual', 'tds', 'safety', 'elec', 'pack', 'cat'];
  var RANGE = { speedy: 'Trotec Speedy range', marker: 'Trotec SpeedMarker range', galvo: 'Trotec SpeedMarker range', sp: 'Trotec SP range' };

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  // A readable title from Trotec's filenames: the model, what the document
  // is, then the version it covers (C/X/R, flexx, fiber, cross) and the
  // Trotec machine group number, so two datasheets never look the same.
  function name(d) {
    var f = String(d.ref).split('?')[0].split('/').pop().replace(/\.pdf$/i, '');
    var bits = [];
    var v = f.match(/\d{3}\s?([CXR])(?=[^a-z]|$)/i) || f.match(/[-_ ]([CXR])[-_ ]/);
    if (v) bits.push(v[1].toUpperCase());
    ['flexx', 'fiber', 'cross', 'stand', 'schemas', 'Safety calculation', 'Pre-Installation'].forEach(function (k) {
      if (f.toLowerCase().indexOf(k.toLowerCase()) > -1) bits.push(lzT(k.replace(/^./, function (c) { return c.toUpperCase(); })));
    });
    var grp = f.match(/(?:^|[^0-9])(80\d\d|0824)(?:[^0-9]|$)/);
    var title = lzT('{model} {doc}', { model: model, doc: (LABEL[d.type] || d.type).toLowerCase() });
    if (bits.length) title += ', ' + bits.join(', ');
    if (grp && grp[1] !== '0824') title += ' (' + grp[1] + ')';
    return title.charAt(0).toUpperCase() + title.slice(1);
  }

  var row = (LZ_DOCS.machines || []).filter(function (r) { return r[0] === model; })[0];
  var docs = row ? row[2].map(function (d) { return { src: d[0], type: d[1], ref: d[2] }; }) : [];
  docs.sort(function (a, b) { return ORDER.indexOf(a.type) - ORDER.indexOf(b.type); });
  var cat = row && RANGE[row[1]] && (LZ_DOCS.catalogues || []).filter(function (r) { return r[0] === RANGE[row[1]]; })[0];
  if (cat) docs.push({ src: 'f', type: 'cat', ref: cat[2][0][1], label: lzT('{name} catalogue', { name: lzT(cat[0]) }) });

  if (!docs.length) {
    list.innerHTML = '<li class="lz-plearn__wait">' + lzT('We send the documents for this model on request. Ask us from your account and we reply the same working day.') + '</li>';
    return;
  }
  list.innerHTML = docs.map(function (d) {
    var href = d.src === 'u' ? d.ref : base + encodeURIComponent(d.ref);
    return '<li><a href="' + esc(href) + '" target="_blank" rel="noopener">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3.5h7.5L19 8v12.5H7z"/><path d="M14 3.5V8h5"/></svg>' +
      '<span>' + esc(d.label || name(d)) + '</span>' +
      '<em class="is-' + esc(d.type) + '">' + esc(LABEL[d.type] || d.type) + '</em></a></li>';
  }).join('');
})();
